import React from 'react';

import { Icon, Layout, Link, Text } from 'ds';
import { CLEANING_SERVICE_PATH } from 'routes';

interface Props {}

const CleaningServiceWidget: React.FC<Props> = () => {
  return (
    <Link href={CLEANING_SERVICE_PATH} color="black" fullWidth fullHeight>
      <Layout direction="column" align="center" gap={16} borderRadius={16} padding={16} color="gray-25" height="100%">
        <Layout direction="column" align="center" gap={4}>
          <Icon name="featherDuster" color="purple-gradient" size={32} />
          <Text size="body-md" color="purple-gradient" align="center" semibold>
            A cleaner office is just a click away.
          </Text>
        </Layout>
        <Layout borderRadius={16} color="purple-gradient" paddingX={12} paddingY={4} display="inline-flex">
          <Text size="body-xs" color="white" semibold>
            Add a cleaning
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default CleaningServiceWidget;
